import { render, staticRenderFns } from "./PendingSales.vue?vue&type=template&id=5d414e98"
import script from "./PendingSales.vue?vue&type=script&lang=js"
export * from "./PendingSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports